module.exports = __webpack_public_path__ + "static/media/tool1.5a769b5c.png";